import { render, staticRenderFns } from "./AccordionMenu.vue?vue&type=template&id=08bc3b7d&scoped=true&"
import script from "./AccordionMenu.vue?vue&type=script&lang=js&"
export * from "./AccordionMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccordionMenu.vue?vue&type=style&index=0&id=08bc3b7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc3b7d",
  null
  
)

export default component.exports